import { computed, type MaybeRefOrGetter, toValue } from "vue";
import type { TravelOrderDto } from "@/api/trips/dto/trip.dto";
import { useFilters } from "@/composables";

export function useTravelOrder(travelOrder: MaybeRefOrGetter<TravelOrderDto>) {
  const travelOrderRef = computed(() => toValue(travelOrder));

  const { round } = useFilters();

  const totalPaymentsAmount = computed(() => {
    return travelOrderRef.value.payments.reduce((acc, payment): number => {
      return round(acc + Number(payment.amount));
    }, 0);
  });

  return {
    totalPaymentsAmount,
  };
}
